import { useState } from "react";
import { MiAutocomplete } from "@miplatform/components";
import { useMaps } from "@miplatform/hooks";
import { TextField } from "@mui/material";

export const ServiceAreaAutocomplete = ({
  value,
  error,
  onBlur,
  onChange,
  isReadOnly,
  ...props
}: ServiceAreaAutocompleteProps) => {
  const [search, setSearch] = useState("");
  const { searchCityState } = useMaps();
  const [options, setOptions] = useState<CityOption[]>([]);

  const handleSearch = async (value: string) => {
    setSearch(value);

    if (value) {
      const cities = await searchCityState(value);
      setOptions(cities);
    }
  };

  const getOptionString = (value: CityOption | undefined) =>
    value ? `${value.city}, ${value.state}` : "";

  return (
    <MiAutocomplete
      fullWidth
      disableClearable
      forcePopupIcon={false}
      error={error as { message: string }}
      // @ts-expect-error changing this will require changes in MiAutocomplete
      options={options}
      getOptionLabel={(value: CityOption | string) =>
        typeof value === "string" ? value : getOptionString(value)
      }
      value={value}
      inputValue={search}
      disabled={isReadOnly}
      getOptionKey={({ city, state }: CityOption) => `${city}-${state}`}
      onInputChange={(_e, value) => handleSearch(value)}
      isOptionEqualToValue={(option: CityOption, value: string) =>
        getOptionString(option) === value
      }
      onBlur={onBlur}
      onChange={(_e, value) => onChange(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          InputLabelProps={{
            ...params.InputLabelProps,
            shrink: true,
          }}
          required
          label="Service Area"
          error={!!error}
          helperText={error?.message}
          InputProps={{
            ...params.InputProps,
            value: search,
          }}
        />
      )}
      {...props}
    />
  );
};

interface ServiceAreaAutocompleteProps {
  value: string;
  city: string;
  state: string;
  error?: { message?: string };
  onChange: (value: CityOption) => void;
  onBlur?: () => void;
  isReadOnly?: boolean;
}

interface CityOption {
  city: string;
  state: string;
}
